var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-grid',{ref:"grid",attrs:{"url":_vm.url,"columns":_vm.columns,"title":_vm.title,"actions":_vm.actions,"onRowClicked":_vm.onRowClicked,"navigationPath":"onRowClicked","navigationField":"onRowClicked","beforeSetupGrid":_vm.beforeSetupGrid,"summaryOptions":{
        enabled: true,
        columns: [
            'totalPaid',
            'paid',
            'credit',
            'debit',
            'scheduledPayments',
            'previousBalance',
            'balance' ],
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }